import React from 'react'

const FtrQuickLinks = () => {
    return (
        <>
        <div className="footer-column clearfix">
            <h3>Quick Links</h3>
            <ul className="footer-menu">
                <li><a href="/index">Home</a></li>
                <li><a href="/">About Us</a></li>
                <li><a href="/">Groups</a></li>
                <li><a href="/">Forums</a></li>
                <li><a href="/">People</a></li>
                <li><a href="/">Blogs</a></li>
            </ul>
        </div>           
        </>
    )
}

export default FtrQuickLinks;